import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\"><path d=\"M1200 0H80A80 80 0 0 0 0 80v864a80 80 0 0 0 80 80h1120a80 80 0 0 0 17.6-2 40 40 0 0 0 27.2-10.4v-2.4A80 80 0 0 0 1280 944V80a80 80 0 0 0-80-80zM640 584L90 90h1103.2zM80 188.4L448.8 520 80 887.6zM508.4 572l106.4 95.6a40 40 0 0 0 53.2 0l113.2-101.2L1128 944H136.4zM840 512.8l360-320v712z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol